import React from 'react';

import Municipality from '../../../types/Municipality';

import Table from '../../common/ui/Table/Table';
import TableHead from '../../common/ui/Table/Head';
import MunicipalitiesTableRow from './TableRow';

interface Props {
  municipalities: Municipality[];
  unauthorizedCallback: () => void;
  showError: (text: string) => void;

  sortData: { column: string; descending: boolean };
  setSortData: (data: { column: string; descending: boolean }) => void;
}

const MunicipalitiesTable = ({
  municipalities,
  unauthorizedCallback,
  showError,
  sortData,
  setSortData,
}: Props) => {
  const municipalitiesRows = municipalities.map((municipality) => (
    <MunicipalitiesTableRow
      key={municipality.id}
      municipality={municipality}
      unauthorizedCallback={unauthorizedCallback}
      showError={showError}
    />
  ));

  return (
    <Table>
      <TableHead
        columns={[{ label: 'Название', width: '100%' }]}
        sortingBy={sortData.column}
        descending={sortData.descending}
        setSortData={setSortData}
      />

      <tbody>{municipalitiesRows}</tbody>
    </Table>
  );
};

export default MunicipalitiesTable;
